const COOKIE_NAME = 'unifiedDevXrayChat';
const COOKIE_MAX_AGE = 60 * 60 * 24 * 365;

/**
 * X-ray chat: whether the coach surface renders the build harness instead of the real chat. The
 * choice is a cluster cookie so it survives a reload like the dev panel's own open state, but the
 * value components read is shared app state — the panel and the coach page are different subtrees,
 * and a per-caller cookie ref would leave the page showing the old surface until a reload.
 */
export const useXrayChatMode = () => {
  const cookie = useClusterCookie<boolean>(COOKIE_NAME, {
    default: () => false,
    maxAge: COOKIE_MAX_AGE,
  });

  const isXrayChat = useState<boolean>('unified-dev-xray-chat', () => cookie.value === true);

  const setXrayChat = (value: boolean) => {
    isXrayChat.value = value;
    cookie.value = value;
  };

  const toggle = () => {
    setXrayChat(!isXrayChat.value);
  };

  return {
    isXrayChat,
    setXrayChat,
    toggle,
  };
};
